import React from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";
import "./DocumentExplorer.scss";
import dateFormat from "dateformat";
import DocumentListView from "./DocumentListView/DocumentListView";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import EmptyStates from "../EmptyStates/EmptyStates";
import emptySubfolderImage from "../../assets/EmptyStates/empty_subfolder.svg";
import { deepCopy, getCapitals, getParsedDate } from "../../helper";
import { connect } from "react-redux";
import {
  mapDispatchToProps,
  mapStateToProps,
} from "../../common/UserDataReducer";
import { Redirect } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

const DOCUMENTS_OF_FOLDER = gql`
  query DocumentsOfFolder($parentId: UUID!) {
    documentsOfFolder(folderId: $parentId) {
      id
      title
      fileUrl
      approvalLevels {
        id
        name
        sequence
        userApproval {
          id
          user {
            id
            isActive
            username
            firstName
            lastName
            email
            profile {
              imageUrl: image
            }
          }
          status
        }
      }
      status {
        id
        name
      }
      tag {
        id
        name
      }
      abstractJson
      folder {
        id
        parentFolder {
          id
        }
      }
      createdBy {
        id
        username
        firstName
        lastName
        email
        profile {
          image
          role {
            id
            name
          }
        }
      }
      modifiedBy {
        firstName
        lastName
        email
        profile {
          image
          role {
            id
            name
          }
        }
      }
      modifiedTs
      documentType {
        id
        title
      }
      sharedDocument {
        id
        user {
          id
          email
          username
          firstName
          lastName
          profile {
            image
            role {
              id
              name
            }
          }
        }
        userRole {
          id
          name
        }
      }
    }
  }
`;

class DocumentExplorer extends React.Component {
  state = {
    documents: [],
    editFolder: false,
    updateFolder: {},
    shareFolder: {},
    checkedShareFolder: {},
    totalCheck: 0,
    type: "document",
    key: Math.random(),
    isLoading: true,
    documentSharedWith: [],
    redirect: false,
    show: false,
    showShareModal: false,
    shareMultipleDocument: true,
    loadDocuments: [],
    folderSharedWith: null,
  };

  componentDidMount() {
    // If subfolders are available use them or fetch subfolders
    const subFolderArr =
      this.props.subFolders[this.props.match.params.folderId];
    if (!subFolderArr) {
      this.fetchSubFolders();
    }
    this.loadData();
  }

  loadData = () => {
    const variables = {
      rootId: this.props.match.params.folderId,
      parentId: this.props.match.params.subId,
    };

    apolloClient
      .query({
        query: DOCUMENTS_OF_FOLDER,
        variables: variables,
      })
      .then((result) => {
        // Shared With data--->

        let documents = [];
        documents = result.data.documentsOfFolder.map((item) => {
          const fieldObj = {};
          const parsedAbstractJson = JSON.parse(item.abstractJson);
          if (item?.status?.name?.toLowerCase() !== "received") {
            parsedAbstractJson.map((parsedJson) => {
              return parsedJson.tabSections.map((tab) => {
                return tab.sectionFields.map((sectionField) => {
                  return sectionField.inputType === "Date"
                    ? (fieldObj[sectionField.fieldLabel] =
                        sectionField.fieldValue
                          ? dateFormat(
                              sectionField.fieldValue,
                              "mmm dd, yyyy",
                              true
                            )
                          : "-")
                    : sectionField.fieldLabel === "Document type" ||
                      sectionField.fieldLabel === "Document Type"
                    ? (fieldObj[getCapitals(sectionField.fieldLabel)] =
                        item.documentType.title)
                    : sectionField.inputType === "Dropdown" &&
                      sectionField.fieldValue === undefined
                    ? (fieldObj[sectionField.fieldLabel] = "-")
                    : (fieldObj[sectionField.fieldLabel] =
                        sectionField.fieldValue);
                });
              });
            });
          }

          const findShareDocument = item.sharedDocument.map(
            (doc) => doc?.user?.email
          );

          return {
            ...item,
            abstractJson: JSON.parse(item.abstractJson),
            folder: {
              ...(item?.folder ?? {}),
              parentFolder: {
                id: this.props.match.params.folderId,
              },
            },
            modifiedOn: getParsedDate(item.modifiedTs),
            "Shared With": findShareDocument.join(", "),
            ...fieldObj,
          };
        });

        this.setState({
          documents: documents,
          loadDocuments: documents,
          isLoading: false,
          documentSharedWith: result.data.documentsOfFolder.map(
            (doc) => doc.sharedDocument
          ),
        });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        this.props.history.push(`/files/${this.props.match.params.folderId}`);
      });
  };

  componentDidUpdate(prevProps) {
    // If current folder is fetched then only set subfolders to avoid unnecessary renders
    const subFolders = this.props.subFolders[this.props.match.params.folderId];
    if (!subFolders) {
      return;
    }
    const folderSharedWith = subFolders.find(
      (subfolder) => subfolder.id === this.props.match.params.subId
    )?.sharedFolder;

    const prevFolderSharedWith = this.state.folderSharedWith;

    if (prevFolderSharedWith === null) {
      this.setState({
        folderSharedWith: folderSharedWith,
      });
      return;
    }

    // @Todo remove this commnet is loading of documents is proper on after some operations
    if (
      this.state.isLoading === false &&
      (folderSharedWith !== prevFolderSharedWith ||
        this.props.match.params.subId !== prevProps.match.params.subId)
    ) {
      this.setState({
        isLoading:
          this.props.match.params.subId !== prevProps.match.params.subId,
        folderSharedWith: folderSharedWith,
      });
      this.loadData();
    }
  }

  getTotalDays = (date) => {
    const dateDay = dateFormat(date, "dd");
    const dateMonth = dateFormat(date, "mm");
    const dateYear = dateFormat(date, "yyyy");

    let first = new Date();
    let second = new Date(
      parseInt(dateYear),
      parseInt(dateMonth) - 1,
      parseInt(dateDay)
    );

    const totalDays = Math.round((second - first) / (1000 * 60 * 60 * 24));
    return totalDays;
  };

  onFolderUpdated = (data) => {
    let rootFolders = [...this.props.rootFolders];
    let subFolders = { ...this.props.subFolders };

    if (data.parentFolderId === null) {
      const findFolderIndex = rootFolders.findIndex(
        (folder) => folder.id === data.editFolder.id
      );
      if (findFolderIndex > -1) {
        rootFolders.splice(findFolderIndex, 1);
        rootFolders.splice(findFolderIndex, 0, data.editFolder);
      }
    } else {
      const subFolderArr = subFolders[data.parentFolderId];
      if (subFolderArr) {
        const findSubFolderIndex = subFolderArr.findIndex(
          (subFolder) => subFolder.id === data.editFolder.id
        );
        if (findSubFolderIndex > -1) {
          const subFolder = subFolderArr[findSubFolderIndex];
          subFolder.title = data.editFolder.title;
          subFolder.color = data.editFolder.color;
          subFolder.description = data.editFolder.description;
          subFolder.instruction = data.editFolder.instruction;
          subFolder.approvalRequired = data.editFolder.approvalRequired;
          subFolder.approvalLevels = data.editFolder.approvalLevels ?? [];
          subFolderArr.splice(findSubFolderIndex, 1);
          subFolderArr.splice(findSubFolderIndex, 0, subFolder);
        }
      }
    }

    this.setState({ editFolder: false, updateFolder: {} });
    this.props.updateFolders({
      rootFolders: rootFolders,
      subFolders: deepCopy(subFolders),
    });
  };

  fetchSubFolders() {
    const variables = {
      parentFolderId: this.props.match.params.folderId,
    };
    apolloClient
      .query({
        query: gql`
          query subFolder($parentFolderId: UUID!) {
            subFolders(parentFolderId: $parentFolderId, skip: 0) {
              folderId: id
              id
              title
              approvalRequired
              approvalLevels {
                id
                name
                users {
                  id
                  isActive
                  username
                  firstName
                  lastName
                  email
                  profile {
                    imageUrl: image
                  }
                }
                sequence
              }
              description
              instruction
              color {
                id
                name
              }
              createdBy {
                id
                username
                firstName
                lastName
                email
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
              modifiedTs
              parentFolder {
                id
                title
              }
              documentSet {
                id
                file
                title
                inTrash
                documentType {
                  id
                  title
                }
              }
              sharedFolder {
                id
                user {
                  id
                  email
                  username
                  firstName
                  lastName
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                userRole {
                  id
                  name
                }
              }
              pinnedFolder {
                user {
                  id
                }
                folder {
                  id
                  title
                }
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        const subFolders = {
          ...this.props.subFolders,
          [this.props.match.params.folderId]: result.data.subFolders,
        };
        this.props.updateFolders({
          rootFolders: this.props.rootFolders,
          subFolders,
        });
      })
      .catch((e) => {});
  }

  onArchiveItem = (data) => {
    let rootFolders = [...this.props.rootFolders];
    let subFolders = { ...this.props.subFolders };

    if (data.parentFolder) {
      const subFolderArr = subFolders[data.parentFolder.id];
      if (subFolderArr) {
        const findSubFolderIndex = subFolderArr.findIndex(
          (subFolder) => subFolder.id === data.id
        );
        if (findSubFolderIndex > -1) {
          subFolderArr.splice(findSubFolderIndex, 1);
        }
      }
      // To update hasSubFolders status if the root folder has no subfolders
      rootFolders = rootFolders.map((folder) => {
        if (folder.id === data.parentFolder.id) {
          return { ...folder, hasSubFolders: subFolderArr.length !== 0 };
        } else {
          return folder;
        }
      });
    }

    // this.props.setRedirect();
    this.props.updateFolders({
      rootFolders: rootFolders,
      subFolders: subFolders,
    });
    this.setState({ redirect: true });
    // this.props.history.push(`/files/${data.parentFolder.id}`);
  };

  setDocuments = (updateDocuments) => {
    this.setState({ documents: updateDocuments });
  };

  setEditFolder = (bool, folder, isEditingASubFolder = false) => {
    this.setState({
      show: !this.state.show,
      editFolder: bool,
      updateFolder: { ...folder },
    });
    this.props.handleIsEditingASubFolder(isEditingASubFolder);
  };

  handleShareModal = () => {
    if (this.state.totalCheck > 0) {
      this.setState({
        totalCheck: 0,
        showShareModal: !this.state.showShareModal,
        shareFolder: {},
      });
    } else {
      this.setState({
        showShareModal: !this.state.showShareModal,
      });
    }
  };

  setShareFolder = (folder) => {
    this.setState({
      showShareModal: !this.state.showShareModal,
      shareFolder: { ...folder },
      type: folder.file ? "document" : false,
    });
  };

  setShareFolders = (checked, totalCheck, updatedSharedWith) => {
    this.setState({
      showShareModal: !this.state.showShareModal,
      checkedShareFolder: checked,
      totalCheck: totalCheck,
    });
  };

  setDocumentsSharedWith = (documentSharedWith) => {
    this.setState({ documentSharedWith });
  };

  handleFolderModal = () => {
    this.setState({ show: !this.state.show });
  };

  sortedDocuments = (docs) => {
    return docs.sort((a, b) =>
      a.title.toLowerCase() > b.title.toLowerCase()
        ? 1
        : a.title.toLowerCase() < b.title.toLowerCase()
        ? -1
        : 0
    );
  };

  updateDocuments = (documents) => {
    this.setState({ documents: documents });
  };

  render() {
    const emptyStateButtons = [
      {
        buttonName: "Add File",
        link: true,
      },
    ];

    if (this.state.redirect) {
      window.history.go(1);
      return <Redirect to={`/files/${this.props.match.params.folderId}`} />;
    }

    return (
      <div className="container-fluid documentview-wraper" id="style-scroll">
        <Breadcrumbs
          documents={this.state.documents}
          itemsCount={this.state.documents.length}
          rootFolderId={this.props.match.params.folderId}
          editFolder={this.state.editFolder}
          onFolderUpdated={this.onFolderUpdated}
          setEditFolder={this.setEditFolder}
          subFolderId={this.props.match.params.subId}
          setShareFolder={this.setShareFolder}
          type={this.state.type}
          updateFolder={this.state.updateFolder}
          shareFolder={this.state.shareFolder}
          setShareFolders={this.setShareFolders}
          totalCheck={this.state.totalCheck}
          checkedShareFolder={this.state.checkedShareFolder}
          getTotalDays={this.getTotalDays}
          onArchiveItem={this.onArchiveItem}
          setDocumentsSharedWith={this.setDocumentsSharedWith}
          showShareModal={this.state.showShareModal}
          handleShareModal={this.handleShareModal}
          showFolderModal={this.state.show}
          handleFolderModal={this.handleFolderModal}
          updateDocuments={this.updateDocuments}
          shareMultipleDocument={this.state.shareMultipleDocument}
          loadData={this.loadData}
          {...this.props}
        />
        {this.state.isLoading ? (
          <div className="loader-icon">
            <Spinner animation="border" role="status" />
          </div>
        ) : this.state.documents.length > 0 ? (
          <DocumentListView
            rootId={this.props.match.params.folderId}
            parentId={this.props.match.params.subId}
            documents={this.sortedDocuments(this.state.documents)}
            setShareFolder={this.setShareFolder}
            loadData={this.loadData}
            setDocuments={this.setDocuments}
            setShareFolders={this.setShareFolders}
            sharedWithList={this.state.documentSharedWith}
            showShareModal={this.state.showShareModal}
            loadDocuments={this.state.loadDocuments}
            {...this.props}
          />
        ) : (
          <div className="is-size-h2 bold no-documents">
            <EmptyStates
              imgSrc={emptySubfolderImage}
              emptyStateTitle="You’ve not added any files yet"
              // breakLine="There"
              emptyStateButtons={emptyStateButtons || []}
              {...this.props}
            />
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentExplorer);
